import {
  GetPublicationListRequest,
  GetPublicationListRequestAction,
} from './types';

export const GET_PUBLICATION_LIST_REQUEST = 'GET_PUBLICATION_LIST_REQUEST';

export const getPublicationListRequest = (
  payload: GetPublicationListRequest,
): GetPublicationListRequestAction => {
  return {
    type: GET_PUBLICATION_LIST_REQUEST,
    payload,
  };
};
